import { render, staticRenderFns } from "./NewSecurityModal.vue?vue&type=template&id=613d02b5&scoped=true&"
import script from "./NewSecurityModal.vue?vue&type=script&lang=ts&"
export * from "./NewSecurityModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewSecurityModal.vue?vue&type=style&index=0&id=613d02b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d02b5",
  null
  
)

export default component.exports